<template>
    <div class="not-found">
        <div class="not-found__inner">
            <p class="not-found__code">404</p>
            <p class="not-found__msg">页面不存在</p>
            <a class="not-found__home" href="/" @click.prevent="goHome">返回首页</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "not-found",
    methods: {
        goHome() {
            this.$router && this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.not-found {
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 20px;
}
.not-found__code {
    font-size: 96px;
    font-weight: 700;
    color: #004ea2;
    margin: 0;
    line-height: 1;
}
.not-found__msg {
    font-size: 18px;
    color: #4e4e4e;
    margin: 20px 0 32px;
}
.not-found__home {
    display: inline-block;
    padding: 10px 24px;
    background: #004ea2;
    color: #fff;
    text-decoration: none;
    border-radius: 30px;
    font-size: 14px;
    transition: all 0.3s;
}
.not-found__home:hover {
    background: #003d82;
}
</style>
